import React from "react";
import { createRoot } from "react-dom/client";

import { getJSON } from "./common/helpers.js";
import SearchPage from "./components/Search/SearchPage.jsx";

export default function renderSearch() {
  const selectors = document.querySelectorAll(".js-search-mount");
  selectors.forEach((mount, i) => {
    let domJSON = "";
    if (mount.dataset.dom) {
      domJSON = JSON.parse(mount.dataset.dom);
    } else {
      console.log("domJSON doesnt exist");
      domJSON = getJSON([mount]);
    }

    const root = createRoot(mount);
    root.render(<SearchPage api={mount.dataset.api} dom={domJSON} loggedIn={mount.dataset.user==="not yet assigned" ? false:true} viewmode={mount.dataset.viewmode} />);
  });
}
